import { render, staticRenderFns } from "./orderManagement.vue?vue&type=template&id=f14fcb4a&scoped=true&"
import script from "./orderManagement.vue?vue&type=script&lang=js&"
export * from "./orderManagement.vue?vue&type=script&lang=js&"
import style0 from "./orderManagement.vue?vue&type=style&index=0&id=f14fcb4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14fcb4a",
  null
  
)

export default component.exports